import { GridColDef } from '@mui/x-data-grid-pro'

export const cullReportCols: GridColDef[] = [
  {
    flex: 2,
    headerName: 'Short Line Name',
    field: 'ShortLineName',
  },
  {
    flex: 1,
    headerName: 'Animal ID',
    field: 'AnimalID',
  },
  {
    flex: 1,
    headerName: 'Container ID',
    field: 'ContainerID',
  },
  {
    flex: 1,
    headerName: 'Rack ID',
    field: 'RackID',
  },
  {
    flex: 1,
    headerName: 'RackName',
    field: 'RackName',
  },
  {
    flex: 2,
    headerName: 'Status',
    field: 'Status',
  },
  {
    flex: 2,
    headerName: 'Status Date',
    field: 'StatusDate',
  },
  {
    flex: 1,
    headerName: 'Comments',
    field: 'Comments',
  },
]
